export enum FilterKeys {
  Distance = 'distance',
  GoodDeals = 'good-deals',
  Diet = 'diet',
  PaymentMethods = 'payment-methods',
  Categories = 'categories',
}
